import { render, staticRenderFns } from "./GroupThresholdSetting.vue?vue&type=template&id=28bc39ab&scoped=true"
import script from "./GroupThresholdSetting.vue?vue&type=script&lang=js"
export * from "./GroupThresholdSetting.vue?vue&type=script&lang=js"
import style0 from "./GroupThresholdSetting.vue?vue&type=style&index=0&id=28bc39ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bc39ab",
  null
  
)

export default component.exports